import clsx from 'clsx';
import { useFormikContext } from 'formik';
import { MouseEvent, useMemo } from 'react';
import { Col, FormControl, Row } from 'react-bootstrap';
import { CellProps } from 'react-table';
import LabelRequired from 'src/app/modules/component/LabelRequired';
import { TableCustomCell } from 'src/app/modules/component/table/components/TableCustomCell';
import { TableCustomHeader } from 'src/app/modules/component/table/components/TableCustomHeader';
import { TableCustom } from 'src/app/modules/component/table/table-custom/TableCustom';
import TextField from 'src/app/modules/component/TextField';
import TableInputField from './TableInputField';

const HoSoPhimAnh = () => {
	const { values, setFieldValue } = useFormikContext<any>();

	const LOAI_GIAY_TO = [
		{
			label: 'X-quang',
			field: 'xrayRecord',
		},
		{
			label: 'CT scanner',
			field: 'ctScanRecord',
		},
		{
			label: 'Siêu âm',
			field: 'ultrasonicRecord',
		},
		{
			label: 'Xét nghiệm',
			field: 'testRecord',
		},
		{
			label: 'Khác',
			field: 'otherRecord',
		},
		{
			label: 'Toàn bộ hồ sơ',
			field: 'totalRecord',
		},
	];

	const COLUMNS = useMemo(() =>[
		{
			Header: (props: any) => (
				<TableCustomHeader
					tableProps={props}
					title="Hồ sơ, phim, ảnh"
					className="text-center text-white px-3 min-w-300px"
				/>
			),
			id: 'hoSoPhimAnh',
			columns: [
				{
					Header: (props: any) => (
						<TableCustomHeader
							tableProps={props}
							title="Loại"
							className="text-center text-white px-3 min-w-200px"
						/>
					),
					id: 'loai',
					Cell: ({ ...props }) => (
						<TableCustomCell data={`- ${props.row.original?.label}`} />
					),
				},
				{
					Header: (props: any) => (
						<TableCustomHeader
							tableProps={props}
							title="Số tờ"
							className="text-center text-white px-3 w-150px"
						/>
					),
					id: 'soGiayTo',
					Cell: ({ row: { original } }: CellProps<any>) => {
						return (
							<TableCustomCell
								className="text-center"
								data={
									<TableInputField
										name={original?.field}
										fieldValue={values?.forms?.[original?.field]}
										updateRowData={(name, value) => {
											setFieldValue(`forms.${name}`, value);
										}}
									/>
								}
							/>
						);
					},
				},
			],
		},
	], [values?.forms]);
	
	return (
		<Row className="spaces pl-4 pt-10">
			<Col md={5} className="pe-0">
				<TableCustom columns={COLUMNS} data={LOAI_GIAY_TO} />
			</Col>
			<Col className="ps-0">
				<div className="border d-flex h-100">
					<div className="flex-1 d-flex flex-column justify-content-between">
						<div
							className={clsx(
								'd-flex flex-column justify-content-between',
								'flex-1',
								'border-bottom p-4'
							)}
						>
							<LabelRequired
								label="Người giao hồ sơ:"
								className="d-block w-100 text-center"
							/>
							<TextField
								name="forms.recordDeliverer"
								label="Họ tên"
								inputClassName="text-center"
							/>
						</div>

						<div
							className={clsx(
								'd-flex flex-column justify-content-between',
								'flex-1',
								'p-4'
							)}
						>
							<LabelRequired
								label="Người nhận hồ sơ:"
								className="d-block w-100 text-center"
							/>
							<TextField
								name="forms.recordReceiver"
								label="Họ tên"
								inputClassName="text-center"
							/>
						</div>
					</div>

					<div
						className={clsx(
							'd-flex flex-column justify-content-between',
							'flex-1',
							'border-start p-4 pt-1'
						)}
					>
						<div>
							<div className="d-flex">
								<TextField
									name="forms.signDay"
									label="Ngày"
									inputClassName="text-center"
								/>
								<TextField
									name="forms.signMonth"
									label="tháng"
									inputClassName="text-center"
								/>
								<TextField
									name="forms.signYear"
									label="năm"
									inputClassName="text-center"
								/>
							</div>
							<LabelRequired
								label="Bác sĩ điều trị"
								className="d-block w-100 text-center pt-3"
							/>
						</div>
						<TextField
							name="forms.medicalDoctorName"
							label="Họ tên"
							inputClassName="text-center"
						/>
					</div>
				</div>
			</Col>
		</Row>
	);
};

export default HoSoPhimAnh;
